<template>
  <BaseCRUDPageLayout :links="links">
    <template v-slot:tableName> إضافة مشروع جديد </template>
    <v-container>
      <v-row>
        <v-col cols="12">
          <CreateProjectForm />
        </v-col>
      </v-row>
    </v-container>
  </BaseCRUDPageLayout>
</template>

<script>
import CreateProjectForm from "../components/forms/CreateProjectForm.vue";

export default {
  data() {
    return {
      links: [
        {
          text: "الصفحة الرئيسية",
          href: "/",
          disabled: false,
        },
        {
          text: "المشاريع",
          href: "/projects",
          disabled: false,
        },
        {
          text: "إضافة مشروع جديد",
          disabled: true,
        },
      ],
    };
  },
  components: { CreateProjectForm },
};
</script>

<style></style>
